import {
    StepVariables,
    ToolContext,
} from "@services/tracking/types/trackingInfo/toolStepTrackingInfo";

enum CALCULATOR_KEYS {
    brick = "brick",
    cementPlate = "cementplate",
    cementScreed = "cementscreed",
    glassBrick = "glassbrick",
    roofing = "roofing",
    stabilizedSand = "stabilizedsand",
    tile = "tile",
    wallpaper = "wallpaper",
    ytong = "ytong",
    corrugateSheet = "corrugatesheet",
    gravel = "gravel"
}

export type CalculatorConfig = {
    start: StepVariables;
    submit: StepVariables;
    context: ToolContext;
};

const getCalculatorConfig = (
    calculatorName: CALCULATOR_KEYS,
): CalculatorConfig => {
    return {
        start: {
            stepName: `Calculator: ${calculatorName}`,
            stepNumber: 1,
            placement: `hulp en advies:calculators:${calculatorName}`,
        },
        submit: {
            stepName: "resultaat",
            stepNumber: 2,
            placement: `hulp en advies:calculators:${calculatorName}`,
        },
        context: {
            name: `${calculatorName} calculator`,
            type: "calculator",
        },
    };
};

export { getCalculatorConfig, CALCULATOR_KEYS };
